import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ListingsService } from '../services/listings.service';
import { Listing } from '../classes/listing';
import { CommunicationService } from '../services/communication.service';
import { ListingCategory, CommercialListingTypes } from '../classes/enums';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class BusinessOpportunitiesResolver implements Resolve<Listing> {

  constructor(
    private _listingsService: ListingsService,
    private _communicationService: CommunicationService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<any> {
    const url = rstate.root.firstChild.url;

    this._communicationService.setCurrentListingType(ListingCategory.COMMERCIAL);
    const cityRegex =  /(.+)-business-opportunities/;
    const province = url[1].path;
    const cityMatches = cityRegex.exec(url[2].path);
    let pageNumber = Number(route.queryParams.page) || 0; // For Pagination

    // We need to remember to decrement this value as pagination arrays start from 0
    if (pageNumber > 0) pageNumber--;
    if (cityMatches && cityMatches.length === 2) {
      let cityName = cityMatches[1];

      // Reformat city name for front end after parsing from URL
      // Capitalize after space, hyphen, slash and replace hyphen with space
      cityName = cityName.replace(/(^\w{1})|([\s-/]{1}\w{1})/g, match => match.toUpperCase());
      cityName = cityName.replace(/-/g, ' ');

      return this.getTotalListings(cityName, province)
                  .pipe(
                    map((count) => {
                      return {city: cityName, province: province, totalListings: count, pageNumber: pageNumber, isBusinessOpportunity: true , propType: CommercialListingTypes.businessOpportunity };
                    })
                  )
    }
    else return of(null);
  }

  private getTotalListings(cityName, province): Observable<Number> {
      return this._listingsService.getListingsCount(false, province, cityName, CommercialListingTypes.businessOpportunity , false)
      .pipe(
        map((count) => {
          return count;
        }),
        catchError((err) => {
          return of(0);
        })
      );

  }
}
